module.exports = __webpack_public_path__ + "img/honeycomb-texture-light.7bc0f390.png";